function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.734 2.133a.53.53 0 0 0-.379.156L2.29 3.355a.535.535 0 0 0 0 .754L6.18 8l-3.89 3.89a.535.535 0 0 0 0 .755l1.066 1.066c.211.207.547.207.754 0L8 9.82l3.89 3.89a.535.535 0 0 0 .755 0l1.066-1.066a.535.535 0 0 0 0-.754L9.82 8l3.89-3.89a.535.535 0 0 0 0-.755L12.645 2.29a.535.535 0 0 0-.754 0L8 6.18 4.11 2.29a.52.52 0 0 0-.376-.156m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#7654fd",
    fillOpacity: 1
  }
}));
export default SvgCloseIcon;